export default __webpack_public_path__ + "static/media/Slide4.8a32bf7a.jpg";